import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const zoomAuthAPI = API('/api/zoomAuth.v1', { type: 'rest' });

const ZoomAuthAPIUtils = {
  link(code: string, isDev?: boolean) {
    const uri = new URI().addQueryParam('action', 'link').addQueryParam('code', code);

    if (isDev) {
      uri.addQueryParam('isDev', true);
    }

    return Q(zoomAuthAPI.post(uri.toString()));
  },

  unlink(isDev?: boolean) {
    const uri = new URI().addQueryParam('action', 'unlink');

    if (isDev) {
      uri.addQueryParam('isDev', true);
    }

    return Q(zoomAuthAPI.post(uri.toString()));
  },
};

export default ZoomAuthAPIUtils;

export const { link, unlink } = ZoomAuthAPIUtils;
